import React from "react";
import PropTypes from "prop-types";
import { cropNumber } from "../../../../../../../common/helpers/helpers";

const GnomadExplainText = ({
  item,
  chromosome,
  explainVisible = false,
  isMito,
}) => {
  const number = item.an || 0;
  const count = item.ac || 0;
  const numberMale = item.an_male || 0;
  const countMale = item.ac_male || 0;
  const acFemale = item.ac_female || 0;
  const anFemale = item.an_female || 0;
  const nhomaltFemale = item.nhomalt_female || 0;
  const numberHom = item.nhomalt || 0;
  const cohort = isMito ? "gnomAD Mitochondrial cohort" : "gnomAD cohort";
  const yAlt = (100 * count) / number;
  const yRef = 100 - yAlt;

  if (explainVisible && /\d/.test(chromosome)) {
    return (
      <div className="varsome-inner-container">
        {"The ALT allele is found in "}
        <strong>{count}</strong>
        {" out of "}
        <strong>{number}</strong>
        {" chromosome "}
        <strong>{chromosome.split("chr")[1]}</strong>
        {" in the gnomAD cohort, and "}
        <strong>{numberHom}</strong>
        {` individual${
          numberHom === 1 ? " is" : "s are"
        } homozygous for the ALT allele. If
        the REF and ALT alleles are the only ones in the population, the
        genotype population frequencies are thus:`}
        {"REF/REF: "}
        <strong>{`${cropNumber(
          ((number - count) * 100) / number,
          3
        )} `}</strong>
        {"REF/ALT: "}
        <strong>
          {`${cropNumber(((count - numberHom * 2) * 100) / number, 3)}% `}
        </strong>
        {"ALT/ALT: "}
        <strong>{`${cropNumber((numberHom * 2 * 100) / number, 3)}% `}</strong>
      </div>
    );
  }

  if (explainVisible && chromosome !== "chrX" && number > 0) {
    return (
      <div className="varsome-inner-container">
        {"The ALT allele is found in "}
        <strong>{count}</strong>
        {" out of "}
        <strong>{number}</strong>
        {" chromosome "}
        <strong>{chromosome.split("chr")[1]}</strong>
        {` in the ${cohort}. If the REF and ALT alleles are the only ones in the population, the genotype population frequencies are thus: REF:`}
        <strong>{`${cropNumber(yRef, 3)}% `}</strong>
        {"ALT: "}
        <strong>{`${cropNumber(yAlt, 3)}%`}</strong>
      </div>
    );
  }

  if (explainVisible && chromosome === "chrX") {
    return (
      <div className="varsome-inner-container">
        {"The ALT allele is found in "}
        <strong>{count}</strong>
        {" out of "}
        <strong>{number}</strong>
        {" chromosome Xs in the gnomAD cohort, and "}
        <strong>{item.nhomalt}</strong>
        {` female individual${
          item.nhomalt === 1 ? " is" : "s are"
        } homozygous for the ALT allele. If the REF and ALT alleles are the only ones in the population, the genotype population frequencies are thus: `}
        <br />
        In males:
        <br />
        {"REF: "}
        <strong>
          {`${cropNumber(((numberMale - countMale) * 100) / numberMale, 3)}% `}
        </strong>
        {"ALT: "}
        <strong>{`${cropNumber((countMale * 100) / numberMale, 3)}% `}</strong>
        <br />
        In females:
        <br />
        {"REF/REF: "}
        <strong>{`${cropNumber((1 - acFemale / anFemale) * 100, 3)}% `}</strong>
        {"REF/ALT: "}
        <strong>
          {`${cropNumber(
            ((acFemale - 2 * nhomaltFemale) / anFemale) * 100,
            3
          )}}%`}
        </strong>
        {"ALT/ALT: "}
        <strong>
          {`${cropNumber(((2 * nhomaltFemale) / anFemale) * 100, 3)}%`}
        </strong>
      </div>
    );
  }
  return null;
};

GnomadExplainText.displayName = "GnomadExplainText";

GnomadExplainText.propTypes = {
  item: PropTypes.shape({
    nhomalt: PropTypes.number,
    ac: PropTypes.number,
    an: PropTypes.number,
    an_male: PropTypes.number,
    ac_male: PropTypes.number,
    ac_female: PropTypes.number,
    an_female: PropTypes.number,
    nhomalt_female: PropTypes.number,
  }).isRequired,
  chromosome: PropTypes.string.isRequired,
  explainVisible: PropTypes.bool,
  isMito: PropTypes.bool,
};

GnomadExplainText.defaultProps = {
  explainVisible: false,
  isMito: false,
};

export default GnomadExplainText;
